"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var console_1 = require("../../../../reducers/slices/console");
var statistics_table_1 = require("./statistics_table");
var StatisticsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Statistics"));
    }, [dispatch]);
    return (0, jsx_runtime_1.jsx)(statistics_table_1.StatisticsTable, {});
};
exports.StatisticsPage = StatisticsPage;
